export * from './default-image.directive';



// WEBPACK FOOTER //
// ./src/app/shared/directives/index.ts